/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf27.png';

const MarketShareStep14 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Place"
    paragraph2={(
      <Fragment>
        In the real world, companies can sell their products directly to customers
        and/or indirectly (e.g. 3rd. party distributor). It all depends on what
        works best. For example, Nike's channel of choice has been indirect sales
        (~84% of their sales). There is, however, a gradual shift towards selling
        directly to consumers because it's now
        optimal. <a href="https://qz.com/2025862/nikes-direct-to-consumer-sales-are-taking-off/" rel="noreferrer" target="_blank">Learn more</a>
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep14;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step14.js